import { RoutePageType } from "./interfaces"
import convitePages from "@modules/convite/pages"

const routesPages: RoutePageType[] = [
    ...convitePages
]

export { routesPages }